
import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import { KryptonElement } from './krypton-element';
export class MessageTicker extends KryptonElement {
    _msg: String;
    text: String = "Please complete your filter selection in order to view data in this ledger.";
    get msg(): String {
        return this._msg;
    }

    @property({ type: String })
    set msg(msg: String) {
        const oldValue = this._msg;
        this._msg = msg;
        this.requestUpdate('msg', oldValue);
    }
    static get styles() {
        return css`
          .message-ticker {
            color: #999999;
            font-size: 2rem;
            line-height: 2.5rem;
          }
        `
    }
    render() {
        return html`
            <div id="message-ticker" class="message-ticker">${this.getMessage()}</div>
        `;
    }
    getMessage(): unknown {
        return html`${this.msg === "prompt-filter" ? this.text : ""}`;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'message-ticker': MessageTicker;
    }
}
